import React from "react";
import "./Meet_Section.css";

const Meet_Section = () => {
  return (
    <section className="Meet_Section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-sm-12 col-12 order-2 order-lg-1">
            <div className="content-box">
              <span className="subtitle">About Us</span>

              <h2>COMPLETE CROP CARE</h2>

              <p className="descn">
                Seedso is a trusted name in modern agriculture, providing
                premium-quality seeds, fertilizers, biofertilizers,
                biostimulants, and crop protection solutions that help farmers
                maximize productivity and crop health.
              </p>

              <p className="descn">
                With a commitment to innovation and sustainable farming, we
                empower growers with reliable agricultural solutions that
                improve soil fertility, strengthen crops, and deliver higher
                yields season after season.
              </p>

              <a href="/about-us" className="discover_btn">
                Discover More
              </a>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 col-12 order-1 order-lg-2">
            <div className="img_holder">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/meet_section/crop_care.jpeg"
                }
                alt="About Seedso"
                className="right_img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Meet_Section;
